'use client'
import { type FC, memo } from 'react'
import styled from 'styled-components'
import { mq, vw, createUnderline, font50, font30, font20, font15 } from '@/styles'
import type { TypeCmsContentText } from '@/schema'

type Props = {
	data: TypeCmsContentText
}

export const ContentText:FC<Props> = memo(({ data }) => {
  const { text } = data
  return (
    <TextContent className='text-wrapper' dangerouslySetInnerHTML={{ __html: text }}  />
  )
})

const TextContent = styled.div`
  color: var(--color-text);
  word-break: break-word;
  width: 100%;

  a {
    ${createUnderline({ height: 1, reverse: true, color: 'var(--color-text)' })}
  }

  h1, h2, h3, h4, h5, h6,
  p, ul, ol, dl,
  q, a {
    color: inherit;
    text-align: center;
    word-break: inherit;
  }

  h1, h2, h3, h4, h5, h6,
  p, ul, ol, dl, q, a {
    color: inherit;
  }

  ul, ol {
    padding-left: 18px;
  }

  ul {
    li {
      list-style-type: disc;
    }
  }

  ol {
    li {
      list-style-type: decimal;
    }
  }

  h1, h2, h3, h4, h5, h6, p, ul, ol, dl, p, q {
    margin-bottom: ${vw(20, 'mobile')};

    /* ${mq.greaterThan('nexus7')} {
      margin-bottom: ${vw(20, 'nexus7')};
    } */

    ${mq.greaterThan('tablet')} {
      margin-bottom: ${vw(30, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-bottom: 30px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  h1, h2 {
    ${font20(true, 400)}

    ${mq.greaterThan('tablet')} {
      ${font20(false, 400)}
    }
  }

  h3 {
    ${font50(true, 400)}

    ${mq.greaterThan('tablet')} {
      ${font50(false, 400)}
    }
  }

  h4 {
    ${font30(true, 400)}

    ${mq.greaterThan('tablet')} {
      ${font30(false, 400)}
    }
  }

  p, h5, h6, a {
    ${font15(true, 300)}
    letter-spacing: -.2px;

    ${mq.greaterThan('tablet')} {
      ${font15(false, 300)}
      letter-spacing: unset;
    }
  }
`
